import React from 'react';
import Reflux from 'reflux';
import PopoverMenu from 'shared/components/menus/popoverMenu.jsx';
import { OrderedMap, Map } from 'immutable';
import PopoverStore from 'shared/flux/stores/PopoverStore';
import PopoverActions from 'shared/flux/actions/PopoverActions';
import CuesheetColumnActions from 'shared/flux/actions/cuesheet/CuesheetColumnActions';
import UserActions from 'shared/flux/actions/UserActions';
import ColumnMenuMixin from 'main/components/show/cuesheet/columnHeaderCell/columnMenuMixin';
import CuesheetStore from 'shared/flux/stores/cuesheet/CuesheetStore';
import UserSessionStore from 'shared/flux/stores/UserSessionStore';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import KeyModifierConstants from 'shared/constants/KeyModifierConstants.jsx';
import {
  ColumnWidthStrings,
  ProofColumnHeaderTitle,
} from 'flux/stores/cuesheet/CuesheetConstants';
import { isMac } from 'shared/lib/platformCheck';
import { isGlobalElementManager } from 'main/components/show/cuesheet/cuesheetViewHelper';

const menuId = 'itemColumnMenu';

export default React.createClass({
  displayName: 'ItemColumnMenu',

  mixins: [
    Reflux.connect(PopoverStore, 'popoverVisibility'),
    Reflux.connectFilter(CuesheetStore, 'displayDescriptions', (state) =>
      state.getIn(['show', 'displayItemDescriptions']),
    ),
    Reflux.connectFilter(
      UserSessionStore,
      'displayProofOfPerformance',
      (state) => state.getIn('preferences', 'displayProofOfPerformance'),
    ),
    Reflux.connectFilter(UserSessionStore, 'userId', (state) =>
      state.get('_id'),
    ),
    PureRenderMixin,
    ColumnMenuMixin,
  ],

  render() {
    const showMenu = this.state.popoverVisibility.get(menuId);

    return (
      <PopoverMenu
        className="cs-item-column-menu"
        config={this._getConfigData()}
        show={showMenu}
      />
    );
  },

  _getConfigData() {
    return Map({
      id: menuId,
      noCaret: false,
      icon: 'angle-down',
      placement: 'bottom',
      onClick: () => PopoverActions.show(menuId),
      onHide: () => PopoverActions.hide(menuId),
      items: this._getItemData(),
    });
  },

  _getItemData() {
    let width = this._getCurrentColumnWidth();
    let displayDescriptions = this.state.displayDescriptions;
    let userId = this.state.userId;

    let { hideProofOfPerformance } = this.props;
    hideProofOfPerformance = isGlobalElementManager();

    return OrderedMap({
      hideDesc: Map({
        content: 'Hide Descriptions',
        onClick: () => this._handleHideDescriptionsClick(),
        hidden: displayDescriptions !== true || true, //TODO: hiding for now, will revisit later
      }),
      showDesc: Map({
        content: 'Show Descriptions',
        onClick: () => this._handleShowDescriptionsClick(),
        hidden: displayDescriptions || true, //TODO: hiding for now, will revisit later
      }),
      showProofColumn: Map({
        hidden: hideProofOfPerformance || this.state.displayProofOfPerformance,
        divider: true,
        content: `Show "${ProofColumnHeaderTitle}" Column`,
        onClick: () =>
          UserActions.updatePreference(
            userId,
            'displayProofOfPerformance',
            true,
          ),
      }),
      setWidthUltraNarrow: Map({
        content: this.getRadioWithLabelNode(
          width === 'ultraNarrow',
          'Set Width Ultra Narrow',
        ),
        onClick: () =>
          this._handleSetColumnWidthClick(ColumnWidthStrings.UltraNarrow),
      }),
      setWidthNarrow: Map({
        content: this.getRadioWithLabelNode(
          width === 'narrow',
          <span>Set Width Narrow {this._getKeyModifier('widthShrink')}</span>,
        ),
        onClick: () =>
          this._handleSetColumnWidthClick(ColumnWidthStrings.Narrow),
      }),
      setWidthNormal: Map({
        content: this.getRadioWithLabelNode(
          width === 'normal',
          <span>Set Width Normal {this._getKeyModifier('widthShrink')}</span>,
        ),
        onClick: () =>
          this._handleSetColumnWidthClick(ColumnWidthStrings.Normal),
      }),
      setWidthWide: Map({
        content: this.getRadioWithLabelNode(
          width === 'wide',
          <span>Set Width Wide {this._getKeyModifier('widthGrow')}</span>,
        ),
        onClick: () => this._handleSetColumnWidthClick(ColumnWidthStrings.Wide),
      }),
      setWidthScriptWide: Map({
        divider: true,
        content: this.getRadioWithLabelNode(
          width === 'scriptWide',
          <span>
            Set Width Script Wide {this._getKeyModifier('widthGrow')}
          </span>,
        ),
        onClick: () =>
          this._handleSetColumnWidthClick(ColumnWidthStrings.ScriptWide),
      }),
    }).filter((item) => item.get('hidden') !== true);
  },

  _getKeyModifier(type) {
    let command = isMac()
      ? KeyModifierConstants.macKeys[type]
      : KeyModifierConstants.windowsKeys[type];

    return <span className="shortcut-key-modifier">{command}</span>;
  },

  _getCurrentColumnWidth() {
    return this.props.settings.getIn(['itemColumn', 'width']);
  },

  _handleHideDescriptionsClick() {
    CuesheetColumnActions.hideItemDescriptions();
  },

  _handleShowDescriptionsClick() {
    CuesheetColumnActions.showItemDescriptions();
  },

  _handleSetColumnWidthClick(width) {
    CuesheetColumnActions.updateItemColumnWidth(width);
  },
});
